import { lazy } from 'react';

export default {
  path: '/books',
  component: lazy(() => import(/* webpackChunkName: 'Books' */ './page'))
};
